import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import auth from '../../services/auth';

import * as todoActions from '../../actions/authenticate';

class UserLogout extends Component {
	constructor(props) {
		super(props);
		auth.clearInfo();
		const { authenticateUser } = this.props;
		authenticateUser(false);
	}

	render() {
		return <Redirect to="/login" />;
	}
}

const mapStateToProps = state => ({
	authenticate: state.authenticate,
});

const mapDispatchToProps = dispatch => bindActionCreators(todoActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UserLogout);
